import { render, staticRenderFns } from "./VideoPageGrid.vue?vue&type=template&id=5299b4ef&scoped=true&"
import script from "./VideoPageGrid.vue?vue&type=script&lang=js&"
export * from "./VideoPageGrid.vue?vue&type=script&lang=js&"
import style0 from "./VideoPageGrid.vue?vue&type=style&index=0&id=5299b4ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5299b4ef",
  null
  
)

export default component.exports